import { render } from "./ProductDuplicateButton.vue?vue&type=template&id=136d1d7b"
import script from "./ProductDuplicateButton.vue?vue&type=script&lang=js"
export * from "./ProductDuplicateButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__